import { clearHyperDXUser } from "$utils/hyperdx";

const INSEE_SNACKBAR =
  "Service INSEE indisponible ou non autorisé (401). Veuillez réessayer plus tard.";

let redirecting = false;

const requestUrlOf = (input: RequestInfo | URL): string => {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.toString();
  return input.url;
};

export const isInseeRequest = (url: string) =>
  url.includes("api.insee.fr") || url.includes("/insee");

const isOnAuthPage = () =>
  window.location.pathname.includes("connexion") ||
  window.location.pathname.includes("mot-de-passe");

const notifyInsee = () => {
  window.dispatchEvent(
    new CustomEvent("app:snackbar:error", {
      detail: { message: INSEE_SNACKBAR },
    })
  );
};

/**
 * A 401 from our APIs (gateway included) ends the session.
 * INSEE is the exception: a third-party 401 must not log the user out.
 */
export const handleUnauthorized = (url = "") => {
  if (typeof window === "undefined" || redirecting) return;
  if (isInseeRequest(url)) {
    notifyInsee();
    return;
  }
  if (isOnAuthPage()) return;

  redirecting = true;
  clearHyperDXUser();
  window.localStorage.removeItem("authState");
  window.localStorage.removeItem("access_token");
  window.localStorage.removeItem("refresh_token");
  window.location.href = "/connexion";
};

export const installFetchUnauthorizedGuard = () => {
  if (typeof window === "undefined") return;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const response = await nativeFetch(input, init);
    if (response.status === 401) {
      handleUnauthorized(requestUrlOf(input));
    }
    return response;
  };
};
